module.exports = __webpack_public_path__ + "img/DE01776.74ad450e.png";